/* import __COLOCATED_TEMPLATE__ from './event-target-preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();